import React, { useEffect, useState } from "react";
import ReactSelect from "react-select";
import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import axios from "axios";
import { ToastContainer } from "react-toastify";
import kmLogo from "../../assets/images/km_logo.png";



const AssignTargetPage = () => {
    /* ================= STATE ================= */
    const [schemes, setSchemes] = useState([]);

    // Loading states
    const [loadingMain, setLoadingMain] = useState(false);
    const [loadingDistrict, setLoadingDistrict] = useState({});
    const [loadingSubDistrict, setLoadingSubDistrict] = useState({});
    const [loadingSurvey, setLoadingSurvey] = useState(false);
    const [surveyGroupWiseData, setSurveyGroupWiseData] = useState([]);

    // Expand states
    const [expandedRows, setExpandedRows] = useState({});
    const [rowChildData, setRowChildData] = useState({});
    const [expandedDistricts, setExpandedDistricts] = useState({});
    const [districtChildData, setDistrictChildData] = useState({});
    const [sortConfig, setSortConfig] = useState({
        key: null,
        direction: "asc"
    });

    // Filters
    const [schemeSearch, setSchemeSearch] = useState("");
    const [stateSearch, setStateSearch] = useState("");
    const [selectedFinYear, setSelectedFinYear] = useState("ALL");
    const [selectedComponentType, setSelectedComponentType] = useState("ALL");

    // Pagination
    const [currentPage, setCurrentPage] = useState(1);
    const recordsPerPage = 10;
    const pageWindowSize = 5;
    const exportToPDF = () => {
        const doc = new jsPDF("p", "mm", "a4");

        // ================= LOGO =================
        const logoWidth = 30;
        const logoHeight = 30;
        const logoX = (doc.internal.pageSize.getWidth() - logoWidth) / 2; // center
        const logoY = 10;

        doc.addImage(
            kmLogo,
            "PNG",
            logoX,
            logoY,
            logoWidth,
            logoHeight
        );

        // ================= DATE & TIME =================
        const now = new Date();
        const formattedDateTime = now.toLocaleString("en-IN", {
            day: "2-digit",
            month: "short",
            year: "numeric",
            hour: "2-digit",
            minute: "2-digit",
            second: "2-digit",
            hour12: true
        });

        // ================= HEADING =================
        doc.setFont("helvetica", "bold");
        doc.setFontSize(18);
        doc.text(
            "Krishi MApper",
            105,
            48,
            { align: "center" }
        );

        doc.setFontSize(14);
        doc.text(
            "Target Monitoring",
            105,
            56,
            { align: "center" }
        );

        // ================= SUB HEADING =================
        doc.setFont("helvetica", "normal");
        doc.setFontSize(10);
        doc.text(
            `Generated on: ${formattedDateTime}`,
            105,
            63,
            { align: "center" }
        );

        // ================= TABLE =================
        const tableColumn = [
            "Scheme",
            "State",
            "Component",
            "Physical Target(By Central)",
            "Physical Achievement(By State)",
            "Target Achieved(Auto Calculated from KM)",
            "Achievement %",
            "Financial Year	"
        ];

        const tableRows = filteredSchemes.map(s => {
            const percentMeta = getAchievementPercentageMeta(s);

            return [
                s.schemeName || "",
                s.stateName || "",
                s.schemeSubTypeName || "",
                `${s.missionTarget || ""} ${s.uomType || ""}`,
                s.physicalAchievment || "",
                `${getTargetAchieved(s) || ""} ${s.uomType || ""}`,
                `${percentMeta.percent} (${percentMeta.label})`,
                s.finYear || ""
            ];
        });


        autoTable(doc, {
            head: [tableColumn],
            body: tableRows,
            startY: 70, // ⬅ no overlap with heading
            theme: "grid",
            styles: {
                fontSize: 9,
                halign: "center",
                valign: "middle"
            },
            headStyles: {
                fillColor: [46, 125, 50],
                textColor: [255, 255, 255],
                fontStyle: "bold"
            }
        });

        // ================= SAVE =================
        doc.save(`Krishi_Mapper_${now.toISOString().split("T")[0]}.pdf`);
    };



    const exportToExcel = () => {
        const dataToExport = filteredSchemes.map(s => ({
            Scheme: s.schemeName,
            State: s.stateName,
            Component: s.schemeSubTypeName,
            Target: `${s.missionTarget} ${s.uomType}`,
            Achievement: s.physicalAchievment,
            Year: s.finYear
        }));
        const ws = XLSX.utils.json_to_sheet(dataToExport);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Schemes");
        XLSX.writeFile(wb, "MissionTarget.xlsx");
    };
    /* ================= API ================= */
    const fetchMissionTargetData = async (payload) => {
        try {
            const baseUrl =
                process.env.NODE_ENV === "development"
                    ? process.env.REACT_APP_DEV_MODE
                    : process.env.REACT_APP_PRO_MODE;
            const baseUrla = "https://km.amnex.co.in/appdevapi";

            const res = await axios.post(
                `${baseUrl}/api/MissionTarget/MissionTarget/GetMissionTargetList`,
                payload,
                {
                    headers: { "Content-Type": "application/json" }
                }
            );

            return res.data?.dataContent || [];
        } catch (err) {
            console.error("API Error", err);
            return [];
        }

    };
    const getTargetAchieved = (row) => {
        if (!surveyGroupWiseData?.length) return 0;

        const surveyMatch = surveyGroupWiseData.find(s =>
            Number(s.schemeCode) === Number(row.schemeCode) &&
            Number(s.stateCode) === Number(row.stateCode) &&
            Number(s.componentId) === Number(row.subTypeCode) &&
            (
                String(row.schemeCode) !== "5" ||
                Number(s.cropGroupCode) === Number(row.cropCategoryCode) &&
                Number(s.cropNameCode) === Number(row.cropNameCode) &&
                Number(s.seasonCode) === Number(row.seasons)
            ) &&
            String(s.finYear) === String(row.finYear) &&
            String(s.uomType) === String(row.uomType)
        );


        if (!surveyMatch) return 0;
        console.log("surveyMatch", surveyMatch)
        const totalSurvey = Number(surveyMatch.totalSurveyArea || 0);
        const missionTarget = Number(row.missionTarget || 0);
        console.log("totalSurvey", totalSurvey)
        console.log("missionTarget", missionTarget)
        const achieved = totalSurvey - missionTarget;
        return totalSurvey;
        // return achieved > 0 ? achieved : 0;
    };

    const getAchievementPercentage = (row) => {
        const missionTarget = Number(row.missionTarget || 0);
        const achieved = Number(getTargetAchieved(row) || 0);

        if (!missionTarget || missionTarget === 0) return 0;

        return ((achieved / missionTarget) * 100).toFixed(2);
    };
    const getAchievementPercentageMeta = (row) => {
        const missionTarget = Number(row.missionTarget || 0);
        const achieved = Number(getTargetAchieved(row) || 0);

        if (!missionTarget) {
            return { percent: "0%", label: "N/A" };
        }

        const percentVal = Math.min((achieved / missionTarget) * 100, 100);
        let label = "Poor";

        if (percentVal > 25 && percentVal <= 50) label = "Better";
        else if (percentVal > 50 && percentVal <= 75) label = "Average";
        else if (percentVal > 75) label = "Excellent";

        return {
            percent: `${percentVal.toFixed(2)}%`,
            label
        };
    };

    const getAchievementMeta = (row) => {
        const missionTarget = Number(row.missionTarget || 0);
        const achieved = Number(getTargetAchieved(row) || 0);

        if (!missionTarget || missionTarget === 0) {
            return { percent: "0.00", color: "bg-secondary", label: "N/A" };
        }

        // ✅ ACTUAL percentage (no cap at 100)
        const percent = (achieved / missionTarget) * 100;

        let color = "bg-danger";
        let label = "Poor";

        if (percent > 25 && percent <= 50) {
            color = "bg-warning";
            label = "Better";
        } else if (percent > 50 && percent <= 75) {
            color = "bg-info";
            label = "Average";
        } else if (percent > 75 && percent <= 100) {
            color = "bg-success";
            label = "Excellent";
        } else if (percent > 100) {
            color = "bg-primary";       // 🔥 over-achievement
            label = "Excess";
        }

        return {
            percent: percent.toFixed(2), // e.g. 900.14%
            color,
            label
        };
    };



    const fetchSurveyGroupWiseData = async () => {
        try {
            const baseUrl =
                process.env.NODE_ENV === "development"
                    ? process.env.REACT_APP_DEV_MODE
                    : process.env.REACT_APP_PRO_MODE;

            const res = await axios.post(
                `${baseUrl}/api/SurveyCountGroupWise/SurveysCountGroupWiseNew`,
                {
                    str_FinYear: "",
                    userLevel: "1",
                    schemeCode: 0
                },
                {
                    headers: { "Content-Type": "application/json" }
                }
            );

            return res.data?.dataContent || [];
        } catch (error) {
            console.error("Survey Group Wise API Error:", error);
            return [];
        }
    };


    /* ================= INITIAL LOAD ================= */
    useEffect(() => {
        const loadInitialData = async () => {
            setLoadingMain(true);
            setLoadingSurvey(true);
            try {
                const [missionList, surveyList] = await Promise.all([
                    fetchMissionTargetData({ schemeCode: 0, UserTypeCode: 1 }),
                    fetchSurveyGroupWiseData()
                ]);

                setSchemes(missionList);
                setSurveyGroupWiseData(surveyList);
            } catch (err) {
                console.error("Initial Load Error", err);
                setSchemes([]);
                setSurveyGroupWiseData([]);
            } finally {
                setLoadingMain(false);
                setLoadingSurvey(false);
            }
        };

        loadInitialData();
    }, []);

    /* ================= FILTER ================= */
    const filteredSchemes = schemes.filter(item => {
        return (
            (!schemeSearch || item.schemeName?.toLowerCase().includes(schemeSearch.toLowerCase())) &&
            (!stateSearch || item.stateName?.toLowerCase().includes(stateSearch.toLowerCase())) &&
            (selectedFinYear === "ALL" || item.finYear === selectedFinYear) &&
            (selectedComponentType === "ALL" || item.schemeSubTypeName === selectedComponentType)
        );
    });



    /* ================= PAGINATION ================= */
    const totalPages = Math.ceil(filteredSchemes.length / recordsPerPage);
    const windowStart =
        Math.floor((currentPage - 1) / pageWindowSize) * pageWindowSize + 1;

    const windowEnd = Math.min(
        windowStart + pageWindowSize - 1,
        totalPages
    );
    const pageNumbers = [];
    for (let i = windowStart; i <= windowEnd; i++) {
        pageNumbers.push(i);
    }
    const handlePageChange = (page) => {
        setCurrentPage(page);
    };
    const handleNext = () => {
        if (currentPage < totalPages) {
            setCurrentPage(prev => prev + 1);
        }
    };
    const handlePrev = () => {
        if (currentPage > 1) {
            setCurrentPage(prev => prev - 1);
        }
    }
    const indexOfLast = currentPage * recordsPerPage;
    const indexOfFirst = indexOfLast - recordsPerPage;
    const sortedSchemes = React.useMemo(() => {
        if (!sortConfig.key) return filteredSchemes;

        return [...filteredSchemes].sort((a, b) => {
            let valA;
            let valB;

            switch (sortConfig.key) {
                case "schemeName":
                case "stateName":
                case "schemeSubTypeName":
                case "finYear":
                    valA = a[sortConfig.key] || "";
                    valB = b[sortConfig.key] || "";
                    return sortConfig.direction === "asc"
                        ? valA.localeCompare(valB)
                        : valB.localeCompare(valA);

                case "missionTarget":
                    valA = Number(a.missionTarget || 0);
                    valB = Number(b.missionTarget || 0);
                    break;

                case "physicalAchievment":
                    valA = Number(a.physicalAchievment || 0);
                    valB = Number(b.physicalAchievment || 0);
                    break;

                case "targetAchieved":
                    valA = Number(getTargetAchieved(a) || 0);
                    valB = Number(getTargetAchieved(b) || 0);
                    break;

                case "achievementPercent":
                    valA = Number(getAchievementMeta(a).percent || 0);
                    valB = Number(getAchievementMeta(b).percent || 0);
                    break;

                default:
                    return 0;
            }

            return sortConfig.direction === "asc" ? valA - valB : valB - valA;
        });
    }, [filteredSchemes, sortConfig]);
    const currentSchemes = sortedSchemes.slice(indexOfFirst, indexOfLast);

    useEffect(() => {
        setCurrentPage(1);
        setExpandedRows({});
        setExpandedDistricts({});
    }, [schemeSearch, stateSearch, selectedFinYear, selectedComponentType]);

    /* ================= FILTER OPTIONS ================= */
    const finYears = ["ALL", ...new Set(schemes.map(i => i.finYear).filter(Boolean))];
    const componentTypes = ["ALL", ...new Set(schemes.map(i => i.schemeSubTypeName).filter(Boolean))];
    const componentOptions = componentTypes.map(t => ({ value: t, label: t }));

    /* ================= SCHEME + ================= */
    const handleToggleRow = async (row) => {
        const rowId = row.id;

        setExpandedRows(prev => ({ ...prev, [rowId]: !prev[rowId] }));

        if (rowChildData[rowId]) return;

        setLoadingDistrict(prev => ({ ...prev, [rowId]: true }));

        try {
            const response = await fetchMissionTargetData({
                ComponentType: 0,
                schemeCode: row.schemeCode,
                StateCode: row.stateCode,
                DistrictCode: 0,
                UserTypeCode: 2,
                SubTypeCode: row.subTypeCode
            });

            setRowChildData(prev => ({ ...prev, [rowId]: response }));
        } finally {
            setLoadingDistrict(prev => ({ ...prev, [rowId]: false }));
        }
    };

    const handleSort = (key) => {
        setSortConfig(prev => {
            if (prev.key === key) {
                return {
                    key,
                    direction: prev.direction === "asc" ? "desc" : "asc"
                };
            }
            return { key, direction: "asc" };
        });
    };



    /* ================= DISTRICT + ================= */
    const handleToggleDistrict = async (schemeRow, districtRow) => {
        const key = `${schemeRow.id}_${districtRow.districtCode}`;

        setExpandedDistricts(prev => ({ ...prev, [key]: !prev[key] }));

        if (districtChildData[key]) return;

        setLoadingSubDistrict(prev => ({ ...prev, [key]: true }));

        try {
            const response = await fetchMissionTargetData({
                ComponentType: 0,
                schemeCode: schemeRow.schemeCode,
                StateCode: schemeRow.stateCode,
                DistrictCode: districtRow.districtCode,
                UserTypeCode: 3,
                SubTypeCode: schemeRow.subTypeCode
            });

            setDistrictChildData(prev => ({ ...prev, [key]: response }));
        } finally {
            setLoadingSubDistrict(prev => ({ ...prev, [key]: false }));
        }
    };
    const getSortIcon = (key) => {
        if (sortConfig.key !== key) return "⇅";
        return sortConfig.direction === "asc" ? "↑" : "↓";
    };

    /* ================= UI ================= */
    return (
        <>
            <ToastContainer autoClose={7000} />
            <style>{`
                @keyframes blink {
                    0%, 100% { opacity: 1; }
                    50% { opacity: 0; }
                }
                .blinking-asterisk {
                    animation: blink 1s infinite;
                    color: #ff0000;
                    font-weight: bold;
                    font-size: 1.2em;
                }
                .highlight-target-header {
                    color: #ff6600;
                    font-weight: bold;
                }
            `}</style>

            <div className="container-fluid mt-4">

                {/* FILTERS */}
                <div
                    className="card shadow-sm mb-4"
                    style={{
                        borderRadius: "16px",
                        background: "linear-gradient(135deg, #f8f9fa, #ffffff)"
                    }}
                >
                    {/* HEADER */}
                    <div className="card-header bg-white border-0 pb-0">
                        <div className="d-flex justify-content-between align-items-center">
                            <h5 className="fw-bold text-success mb-0">
                                <i className="bi bi-funnel-fill me-2"></i>
                                Filter Criteria
                            </h5>

                            <button
                                className="btn btn-sm btn-outline-secondary"
                                onClick={() => {
                                    setSchemeSearch("");
                                    setStateSearch("");
                                    setSelectedFinYear(finYears[0]);
                                    setSelectedComponentType("ALL");
                                }}
                            >
                                <i className="bi bi-arrow-clockwise me-1"></i>
                                Reset
                            </button>
                        </div>
                    </div>

                    {/* BODY */}
                    <div className="card-body pt-3">
                        <div className="row g-4">

                            {/* SCHEME */}
                            <div className="col-md-3">
                                <label className="form-label fw-semibold text-muted">
                                    Scheme
                                </label>
                                <ReactSelect
                                    options={[
                                        { value: "ALL", label: "ALL" },
                                        ...[...new Set(schemes.map(s => s.schemeName))].map(name => ({
                                            value: name,
                                            label: name
                                        }))
                                    ]}
                                    value={{ value: schemeSearch, label: schemeSearch }}
                                    onChange={option => setSchemeSearch(option.value)}
                                    placeholder="Select Scheme"
                                    isSearchable
                                    classNamePrefix="react-select"
                                />
                            </div>

                            {/* STATE */}
                            <div className="col-md-3">
                                <label className="form-label fw-semibold text-muted">
                                    State
                                </label>
                                <ReactSelect
                                    options={[
                                        { value: "ALL", label: "ALL" },
                                        ...[...new Set(schemes.map(s => s.stateName))].map(name => ({
                                            value: name,
                                            label: name
                                        }))
                                    ]}
                                    value={{ value: stateSearch, label: stateSearch }}
                                    onChange={option => setStateSearch(option.value)}
                                    placeholder="Select State"
                                    isSearchable
                                    classNamePrefix="react-select"
                                />
                            </div>

                            {/* FIN YEAR */}
                            <div className="col-md-3">
                                <label className="form-label fw-semibold text-muted">
                                    Financial Year
                                </label>
                                <select
                                    className="form-select shadow-sm"
                                    value={selectedFinYear}
                                    onChange={e => setSelectedFinYear(e.target.value)}
                                >
                                    {finYears.map(y => (
                                        <option key={y} value={y}>{y}</option>
                                    ))}
                                </select>
                            </div>

                            {/* COMPONENT */}
                            <div className="col-md-3">
                                <label className="form-label fw-semibold text-muted">
                                    Component Type
                                </label>
                                <ReactSelect
                                    options={componentOptions}
                                    value={componentOptions.find(o => o.value === selectedComponentType)}
                                    onChange={option => setSelectedComponentType(option.value)}
                                    placeholder="Select Component"
                                    isSearchable
                                    classNamePrefix="react-select"
                                />
                            </div>

                        </div>
                    </div>
                </div>


                <div className="mb-3 d-flex justify-content-end gap-2">
                    <button className="btn btn-success btn-sm" onClick={exportToExcel}>
                        Export to Excel
                    </button>
                    <button className="btn btn-danger btn-sm" onClick={exportToPDF}>
                        Export to PDF
                    </button>
                </div>
                {/* MAIN TABLE */}
                <table className="table table-hover assigntable">
                    <thead className="table-success">
                        <tr>
                            <th>#</th>
                            <th onClick={() => handleSort("schemeName")} style={{ cursor: "pointer" }}>Scheme {getSortIcon("schemeName")}</th>
                            <th onClick={() => handleSort("stateName")} style={{ cursor: "pointer" }}>
                                State {getSortIcon("stateName")}
                            </th>
                            <th onClick={() => handleSort("schemeSubTypeName")} style={{ cursor: "pointer" }}>
                                Component {getSortIcon("schemeSubTypeName")}
                            </th>

                            <th
                                className="text-center"
                                onClick={() => handleSort("missionTarget")}
                                style={{ cursor: "pointer" }}
                            >
                                Physical Target <br />
                                <small className="text-muted">(By Central)</small>
                                {getSortIcon("missionTarget")}
                            </th>

                            <th onClick={() => handleSort("physicalAchievment")} style={{ cursor: "pointer" }}>
                                Physical Achievement <br />
                                <small className="text-muted">(By State)</small>
                                {getSortIcon("physicalAchievment")}
                            </th>

                            <th onClick={() => handleSort("targetAchieved")} className="highlight-target-header" style={{ cursor: "pointer", whiteSpace: 'normal', lineHeight: '1.4' }}>
                                <span style={{ color: 'black', fontWeight: 'bold' }}>Target Achieved</span>
                                <small className="text-muted">(KM Calculated)</small>
                                <span className="blinking-asterisk">*</span>
                                <span style={{ color: 'blue', fontSize: '0.9em' }}>(Area calculated based on polygon area)</span>
                                {getSortIcon("targetAchieved")}
                            </th>
                            <th
                                className="text-center"
                                onClick={() => handleSort("achievementPercent")}
                                style={{ cursor: "pointer" }}
                            >
                                Target Achieved % <br />
                                <small className="text-muted">(KM Calculated)</small>
                                {getSortIcon("achievementPercent")}
                            </th>
                            <th onClick={() => handleSort("finYear")} style={{ cursor: "pointer" }}>
                                Financial Year {getSortIcon("finYear")}
                            </th>
                            <th></th>
                        </tr>
                    </thead>

                    <tbody>
                        {loadingMain && (
                            <tr>
                                <td colSpan="8" className="text-center py-4">
                                    <div className="spinner-border text-primary" />
                                </td>
                            </tr>
                        )}

                        {!loadingMain && currentSchemes.length === 0 && (
                            <tr>
                                <td colSpan="8" className="text-center text-muted py-4">
                                    Data not found
                                </td>
                            </tr>
                        )}

                        {currentSchemes.map((s, i) => (
                            <React.Fragment key={s.id}>

                                {/* MAIN ROW */}
                                {s.missionTarget !== "0.00" && (
                                    <tr>
                                        <td>{indexOfFirst + i + 1}</td>
                                        <td>{s.schemeName}</td>
                                        <td>{s.stateName}-{s.schemeCode}</td>
                                        <td>
                                            {s.schemeSubTypeName}
                                            {s.schemeCode === 5 && s.cropName ? ` - ${s.cropName}` : ""}
                                        </td>
                                        <td>
                                            {s.uomType === "Nos"
                                                ? parseInt(s.missionTarget, 10)
                                                : Number(s.missionTarget).toFixed(2)
                                            } {s.uomType}
                                        </td>
                                        <td>{s.physicalAchievment}</td>
                                        <td
                                            className="fw-semibold text-success"
                                            style={{
                                                backgroundColor: "#e8f5e9",   // light green
                                            }}
                                        >
                                            {getTargetAchieved(s)} {s.uomType}
                                        </td>
                                        <td style={{ minWidth: "160px" }}>
                                            {(() => {
                                                const meta = getAchievementMeta(s);

                                                return (
                                                    <>
                                                        <div className="d-flex justify-content-between mb-1">
                                                            <small className="fw-semibold">{meta.percent}%</small>
                                                            <small className="fw-bold">{meta.label}</small>
                                                        </div>

                                                        <div className="progress" style={{ height: "12px" }}>
                                                            <div
                                                                className={`progress-bar ${meta.color}`}
                                                                role="progressbar"
                                                                style={{ width: `${meta.percent}%` }}
                                                                aria-valuenow={meta.percent}
                                                                aria-valuemin="0"
                                                                aria-valuemax="100"
                                                            />
                                                        </div>
                                                    </>
                                                );
                                            })()}
                                        </td>


                                        <td
                                            className="fw-semibold"
                                            style={{
                                                backgroundColor: "#e3f2fd",   // light blue
                                            }}
                                        >
                                            {s.finYear}
                                        </td>

                                        <td>
                                            <button
                                                className="btn btn-sm btn-outline-success"
                                                onClick={() => handleToggleRow(s)}
                                            >
                                                {expandedRows[s.id] ? "−" : "+"}
                                            </button>
                                        </td>
                                    </tr>
                                )}

                                {/* DISTRICT TABLE */}
                                {expandedRows[s.id] && (
                                    <tr>
                                        <td colSpan="9" className="bg-light p-3">
                                            {loadingDistrict[s.id] ? (
                                                <div className="text-center">
                                                    <div className="spinner-border text-secondary" />
                                                </div>
                                            ) : rowChildData[s.id]?.length === 0 ? (
                                                <div className="text-center text-muted">Data not found</div>
                                            ) : (
                                                <table className="table table-sm assigntable">
                                                    <thead>
                                                        <tr>
                                                            <th>District</th>
                                                            <th>Physical Target</th>
                                                            <th>Physical Achievement</th>
                                                            <th>Target Achieved (KM)</th>
                                                            <th></th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {rowChildData[s.id].map(d => {
                                                            const key = `${s.id}_${d.districtCode}`;
                                                            return (
                                                                <React.Fragment key={key}>
                                                                    <tr>
                                                                        <td>{d.districtName}</td>
                                                                        <td>
                                                                            {d.uomType === "Nos"
                                                                                ? parseInt(d.missionTarget, 10)
                                                                                : Number(d.missionTarget).toFixed(2)
                                                                            } {d.uomType}
                                                                        </td>
                                                                        <td>{d.physicalAchievment}</td>
                                                                        <td>00</td>
                                                                        <td>
                                                                            <button
                                                                                className="btn btn-sm btn-outline-primary"
                                                                                onClick={() => handleToggleDistrict(s, d)}
                                                                            >
                                                                                {expandedDistricts[key] ? "−" : "+"}
                                                                            </button>
                                                                        </td>
                                                                    </tr>

                                                                    {expandedDistricts[key] && (
                                                                        <tr>
                                                                            <td colSpan="3">
                                                                                {loadingSubDistrict[key] ? (
                                                                                    <div className="text-center">
                                                                                        <div className="spinner-border spinner-border-sm" />
                                                                                    </div>
                                                                                ) : districtChildData[key]?.length === 0 ? (
                                                                                    <div className="text-center text-muted">
                                                                                        Data not found
                                                                                    </div>
                                                                                ) : (
                                                                                    <table className="table table-sm table-bordered">
                                                                                        <thead>
                                                                                            <tr>
                                                                                                <th>Sub District</th>
                                                                                                <th>Physical Target</th>
                                                                                                <th>Physical Achievement</th>
                                                                                                <th>Target Achieved (KM)</th>
                                                                                            </tr>
                                                                                        </thead>
                                                                                        <tbody>
                                                                                            {districtChildData[key].map((sd, k) => (
                                                                                                <tr key={k}>
                                                                                                    <td>{sd.subDistrictName}</td>
                                                                                                    <td>
                                                                                                        {sd.uomType === "Nos"
                                                                                                            ? parseInt(sd.missionTarget, 10)
                                                                                                            : Number(sd.missionTarget).toFixed(2)
                                                                                                        } {sd.uomType}
                                                                                                    </td>
                                                                                                    <td>{d.physicalAchievment}</td>
                                                                                                    <td>00</td>
                                                                                                </tr>
                                                                                            ))}
                                                                                        </tbody>
                                                                                    </table>
                                                                                )}
                                                                            </td>
                                                                        </tr>
                                                                    )}
                                                                </React.Fragment>
                                                            );
                                                        })}
                                                    </tbody>
                                                </table>
                                            )}
                                        </td>
                                    </tr>
                                )}

                            </React.Fragment>
                        ))}

                    </tbody>
                </table>

                {/* PAGINATION */}
                <nav className="d-flex justify-content-center mt-3">
                    <ul className="pagination">

                        {/* PREV */}
                        <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
                            <button className="page-link" onClick={handlePrev}>
                                Prev
                            </button>
                        </li>

                        {/* PAGE NUMBERS (ONLY 5) */}
                        {pageNumbers.map((page) => (
                            <li
                                key={page}
                                className={`page-item ${currentPage === page ? "active" : ""}`}
                            >
                                <button
                                    className="page-link"
                                    onClick={() => handlePageChange(page)}
                                >
                                    {page}
                                </button>
                            </li>
                        ))}

                        {/* NEXT */}
                        <li className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}>
                            <button className="page-link" onClick={handleNext}>
                                Next
                            </button>
                        </li>

                    </ul>
                </nav>


            </div>
        </>
    );
};

export default AssignTargetPage;
